import React from 'react';
import { View, StyleSheet } from 'react-native';
import Translations from 'src/core/utils/Translations';
import NavBar from 'src/presentation/components/organisms/NavBar';
import EmptyState from 'src/presentation/components/molecules/EmptyState';
import Colors from 'src/core/utils/Colors';

/**
 * Web sibling of the QR scanner: it explains that scanning belongs in the app, and never touches
 * the camera.
 *
 * Scanning a code is not something a website should do -- decision by Jasper, 26-08-2026. The
 * button that offers it is already native-only (AddEvent sends a browser straight to the code
 * entry), but the route itself stays reachable: type `/scannen`, or follow an old link, and the
 * native screen mounts `CameraView` from expo-camera, which on web becomes `getUserMedia`. Measured
 * on 26-08-2026: a browser really does get asked for the camera there, and when it is refused the
 * app shows an iOS instruction ("Ga naar Instellingen > Topicus Events > Camera") that means
 * nothing in a browser.
 *
 * A sibling rather than a `Platform.OS` branch, for the same reason as MediaLibraryService: this
 * keeps expo-camera's web implementation out of the request entirely, so no permission prompt can
 * appear before a guard runs. It also removes the app's only reason to ask the embedding page for
 * camera access, which is why the hosting request no longer needs a Permissions-Policy question.
 */
export default function QrScannerScreen() {
	return (
		<View style={styles.container}>
			<NavBar
				backBtn={true}
				bgcolor={Colors.primary}
				centerTitle={true}
				color={Colors.black}
				editBtn={false}
				title={Translations.titleQrScanner}
			/>
			<EmptyState
				icon="phone-portrait-outline"
				message={Translations.qrWebOnlyMessage}
				title={Translations.qrWebOnlyTitle}
			/>
		</View>
	);
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: Colors.white,
	},
});
